import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["error", "className", "title", "caption", "required", "placeholder", "defaultValue", "textSecurity", "allowChanged", "forbidChange"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import styles from "@/styles/Form.module.scss";
import classnames from "classnames";
import { forwardRef, useMemo } from "react";
import ErrorMessage from "./ErrorMessage";
import { usePreventContextMenu } from "@/hooks";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var TextField = /*#__PURE__*/forwardRef(function (props, ref) {
  var _classnames;

  var error = props.error,
      className = props.className,
      title = props.title,
      caption = props.caption,
      required = props.required,
      placeholder = props.placeholder,
      defaultValue = props.defaultValue,
      _props$textSecurity = props.textSecurity,
      textSecurity = _props$textSecurity === void 0 ? false : _props$textSecurity,
      allowChanged = props.allowChanged,
      forbidChange = props.forbidChange,
      _props = _objectWithoutProperties(props, _excluded);

  var _usePreventContextMen = usePreventContextMenu(),
      _usePreventContextMen2 = _slicedToArray(_usePreventContextMen, 2),
      on = _usePreventContextMen2[0],
      off = _usePreventContextMen2[1];

  var defaultValueProps = useMemo(function () {
    var _defaultValue = function () {
      if (_props !== null && _props !== void 0 && _props.value) return null;
      if (defaultValue) return defaultValue;
      return "";
    }();

    var props = {};

    if (_defaultValue) {
      props.defaultValue = _defaultValue;
    }

    return props;
  }, [_props === null || _props === void 0 ? void 0 : _props.value, defaultValue]);
  return /*#__PURE__*/_jsxs("div", {
    className: styles.inputField,
    children: [title && /*#__PURE__*/_jsx("legend", {
      className: classnames(styles.formTitle, (_classnames = {}, _defineProperty(_classnames, styles.required, required), _defineProperty(_classnames, styles.allowChanged, allowChanged), _defineProperty(_classnames, styles.forbidChange, forbidChange), _classnames)),
      children: title
    }), /*#__PURE__*/_jsx("input", _objectSpread(_objectSpread({
      ref: ref,
      type: "text",
      placeholder: placeholder,
      className: classnames(styles.textInput, className, _defineProperty({}, styles.textSecurity, textSecurity)),
      required: required,
      onFocus: off,
      onBlur: on
    }, _props), defaultValueProps)), error && /*#__PURE__*/_jsx(ErrorMessage, {
      msg: error
    }), caption && /*#__PURE__*/_jsx("p", {
      className: styles.textInputCaption,
      children: caption
    })]
  });
});
TextField.displayName = "TextField";
export default TextField;